<template>
  <div>
    <div class="tier-plan-box active-plan" :class="{ current: isCurrent }">
      <div class="tier-plan-box--badge" v-if="isCurrent">
        {{ $gettext('Current plan') }}
      </div>
      <h2 class="tiername">
        {{ tierData.name }}
        <GkBadge
          v-if="!tierData.is_free"
          icon-only
          icon="fa-solid fa-crown"
          type="premium"
          hide-tooltip
          size="lg"
          no-shadow
        />
      </h2>
      <div class="tier-plan-box__top">
        <div class="tier-plan-box__top--description">
          {{ tierData.description }}
          <ul class="tier-plan-box__bottom--features">
            <li v-for="(f, i) in featuresList" :key="i">{{ f }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GekkoButton from '@/components/GekkoButton.vue'
import GkBadge from '@/components/GkBadge.vue'
export default {
  name: 'ActivePlanBox',
  components: {
    GekkoButton,
    GkBadge,
  },
  props: {
    tierData: {
      type: Object,
      default: () => {},
    },
    activeDiscount: {
      type: Object,
      default: () => {},
    },
    yearlyCycle: {
      type: Boolean,
      default: false,
    },
    cycleMultiplier: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      isWaitingForResponse: 'main/isWaitingForResponse',
      getProductByTierId: 'subscriptionStore/getProductByTierId',
      activePlan: 'subscriptionStore/getActivePlan',
      currentTier: 'subscriptionStore/getCurrentTier',
    }),
    featuresList() {
      const s = this.tierData && this.tierData.features ? this.tierData.features : ''
      return s
        .replace(/#max_conn#/g, String(this.tierData.max_connections))
        .split(/\r?\n/) // handles \n and \r\n
        .map((x) => x.trim())
        .filter(Boolean)
    },
    featuresTitleText() {
      return this.$gettext('With %{ tiername }, you get:')
    },
    isFreeUser() {
      return !this.activePlan
    },
    isCurrent() {
      return (
        (this.isFreeUser && this.tierData.is_free) || (!this.isFreeUser && this.tierData.id === this.currentTier.id)
      )
    },
    upgradeEvent() {
      return this.isUpgrade ? 'update-subscription' : 'downgrade-subscription'
    },
  },
}
</script>

<style lang="scss">

</style>

